import amioWebappHttpClient from './http/amio-webapp.http-client'
import {
  handleListResponse,
  handleSingleDataResponse,
  handleError
} from '@/services/amio-api/utils/request-utils'
import merge from 'ramda/src/merge'

class ChannelService {
  constructor() {
    this.path = '/channels'
  }

  list(params = {}, ignoredHttpStatuses = []) {
    const _params = merge({offset: 0, max: parseInt(process.env.VUE_APP_LIST_MAX_SIZE)}, params)
    return amioWebappHttpClient
      .get(this.path, {
        params: _params
      })
      .then(handleListResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  getLogs(channelId, params = {}, ignoredHttpStatuses = []) {
    const _params = merge({offset: 0, max: parseInt(process.env.VUE_APP_LIST_MAX_SIZE)}, params)
    return amioWebappHttpClient
      .get(`${this.path}/${channelId}/events`, {
        params: _params
      })
      .then(handleListResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  getIntegrations(channelId, params = {}, ignoredHttpStatuses = []) {
    const _params = merge({offset: 0, max: parseInt(process.env.VUE_APP_LIST_MAX_SIZE)}, params)
    return amioWebappHttpClient
      .get(`${this.path}/${channelId}/integrations`, {
        params: _params
      })
      .then(handleListResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  get(id, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .get(`${this.path}/${id}`)
      .then(handleSingleDataResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  create(data, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .post(`${this.path}`, data)
      .then(handleSingleDataResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  patch(id, patch, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .patch(`${this.path}/${id}`, patch)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  update(id, data, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .put(`${this.path}/${id}`, data)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  delete(id, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .delete(`${this.path}/${id}`)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }
}

export default new ChannelService()
